import React from 'react';

import { Box } from '../../atoms/box/box';
import { Button } from '../../atoms/button/button';
import { Image } from '../../atoms/image/image';

interface LightboxImage {
    srcSet: {
        source: string;
        width: number;
    }[];
    defaultSrc: string;
    altText: string;
    caption: string;
}

interface LightboxProps {
    // image array
    images?: Array<LightboxImage>;
    // modal
    modal?: boolean;
    lightboxId?: string;
}

const Lightbox: React.FunctionComponent<LightboxProps> = ({
    images = [],
    modal = false,
    lightboxId,
}) => {
    // const prefixedLightboxId = LightboxComponent.lightboxId(lightboxId);
    const prefixedLightboxId = lightboxId;

    return (
        <div
            className="m-lightbox"
            id={prefixedLightboxId}
            aria-label="Image Lightbox"
        >
            <Box modal={modal} modalId={prefixedLightboxId}>
                <div className="m-lightbox__closeBar">
                    <Button
                        action="close"
                        mode="integrated"
                        icon={{ iconName: 'close', isUiIcon: true }}
                        aria-label="close lightbox"
                    />
                </div>
                {images.map((image: LightboxImage, index: number) => {
                    const { srcSet, altText, defaultSrc } = image;
                    const key = `image-${index}`;
                    const { caption } = image;

                    return (
                        <Image
                            srcSet={srcSet}
                            defaultSrc={defaultSrc}
                            altText={altText}
                            caption={caption}
                            key={key}
                        />
                    );
                })}
                <div className="m-lightbox__controlBar">
                    {images.length > 1 && (
                        <div className="m-lightbox__controlBar__counter">
                            1 of {images.length}
                        </div>
                    )}
                    <div className="m-lightbox__controlBar__collapseBtn">
                        <div className="m-lightbox__controlBar__collapseBtn__collapse" />
                    </div>
                    {images.length > 1 && (
                        <div className="m-lightbox__controlBar__btnWrapper">
                            <div className="m-lightbox__controlBar__backBtn">
                                <div className="m-lightbox__controlBar__back--disabled" />
                            </div>
                            <div className="m-lightbox__controlBar__nextBtn">
                                <div className="m-lightbox__controlBar__next" />
                            </div>
                        </div>
                    )}
                </div>
            </Box>
        </div>
    );
};

export { Lightbox, LightboxProps };
